import React from 'react'
import { ComponentProps } from '@stitches/react'
import * as Styles from './Button.styles'

export interface ButtonProps extends ComponentProps<typeof Styles.Root> {

}

export function Button(props: ButtonProps) {
    return (
        <Styles.Root {...props}/>
    )
}
